// src/actions/libraryCardActions.js
// Generic DDB store actions — used by brand kit, theme bootstrapper, and any
// entity that serializes to/from the LibraryCard AppSync schema.
import {
  GET_LIBRARY_CARD_REQUEST,
  GET_LIBRARY_CARD_SUCCESS,
  GET_LIBRARY_CARD_FAILURE,
  UPDATE_LIBRARY_CARD_REQUEST,
  UPDATE_LIBRARY_CARD_SUCCESS,
  UPDATE_LIBRARY_CARD_FAILURE,
  REQUEST_PRESIGNED_URL,
  REQUEST_PRESIGNED_URL_SUCCESS,
  REQUEST_PRESIGNED_URL_FAILURE,
} from "./types";

export const getLibraryCardRequest = (payload) => ({
  type: GET_LIBRARY_CARD_REQUEST,
  payload,
});

export const getLibraryCardSuccess = (data) => ({
  type: GET_LIBRARY_CARD_SUCCESS,
  payload: data,
});

export const getLibraryCardFailure = (error) => ({
  type: GET_LIBRARY_CARD_FAILURE,
  payload: error,
});

export const updateLibraryCardRequest = (payload) => ({
  type: UPDATE_LIBRARY_CARD_REQUEST,
  payload,
});

export const updateLibraryCardSuccess = (data) => ({
  type: UPDATE_LIBRARY_CARD_SUCCESS,
  payload: data,
});

export const updateLibraryCardFailure = (error) => ({
  type: UPDATE_LIBRARY_CARD_FAILURE,
  payload: error,
});

export const requestPresignedUrl = (payload) => ({
  type: REQUEST_PRESIGNED_URL,
  payload,
});

export const requestPresignedUrlSuccess = (data) => ({
  type: REQUEST_PRESIGNED_URL_SUCCESS,
  payload: data,
});

export const requestPresignedUrlFailure = (error) => ({
  type: REQUEST_PRESIGNED_URL_FAILURE,
  payload: error,
});
